import React from 'react';
import { useQuery } from '@apollo/client';
import { Field } from 'formik';
import ReactSelect from 'components/Fields/ReactSelect';
import Loader from 'components/common/Loader';
import { PERMISSION_LIST } from 'utils/CommonGraphQL';

const PermissionField = ({ roles }) => {
  const rolesId = roles?.map((r) => r.id).toString() || '0';
  const { data, loading, error } = useQuery(PERMISSION_LIST, {
    variables: {
      filter: {
        key: 'id',
        value: rolesId,
        setAttribute: 'roles',
        type: 'INT',
        op: 'NOT_IN',
      },
      pagination: false,
      sortCol: null,
      sortDirection: null,
    },
    fetchPolicy: 'network-only',
  });
  if (loading) return <Loader />;
  if (error) return `There is an error on this page : ${error.message} `;
  return (
    <div>
      <Field
        name="newPermissions"
        label="Permissions"
        type="select"
        component={ReactSelect}
        data={data?.permissions?.permissions}
        keys={{ id: 'id', label: 'label' }}
        getOptionValue={(option) => option.name}
        getOptionLabel={(option) => option.permissionName}
        isMulti
        // {...rest}
      />
    </div>
  );
};

export default PermissionField;
